/* run_os_plans.icon.svg.js */

module.exports = {
    icon: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.65 20.36" preserveAspectRatio="none">
            <path class="foreground-gl" d="M444.8,4.57a5.57,5.57,0,1,0,5.57,5.57A5.57,5.57,0,0,0,444.8,4.57Zm-.94,9.52v-8l4.3,4.14Z" transform="translate(-427.72 -0.04)" />
            <path class="foreground-gl" d="M316.77,17.15a7,7,0,0,1-4.06-1.29l-3,3.22-6-6.53h3.6V8.67h-3.6l6-7.24,2.63,3.16a7,7,0,0,1,4.4-1.54l.39,0a10.18,10.18,0,1,0-7.29,17.27,10.1,10.1,0,0,0,7.41-3.22C317.11,17.13,316.94,17.15,316.77,17.15Z" transform="translate(-299.69 0.02)" />
        </svg>
    `
};
